// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1owcQ","cell":"ColumnAccessor_cell__WuhsI","firstCellAccent":"ColumnAccessor_firstCellAccent__vFwxg"};